import { lazy } from "react";

const RELOAD_KEY = "chunk-reload-attempt";

const isChunkLoadError = (error) => {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;
  const message = String(error.message || "");
  return /Loading chunk [\w-]+ failed/i.test(message) || /Loading CSS chunk/i.test(message);
};

export default function lazyWithRetry(componentImport) {
  return lazy(async () => {
    const alreadyReloaded = window.sessionStorage.getItem(RELOAD_KEY) === "1";
    try {
      const component = await componentImport();
      window.sessionStorage.removeItem(RELOAD_KEY);
      return component;
    } catch (error) {
      if (!alreadyReloaded && isChunkLoadError(error)) {
        window.sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return { default: () => null };
      }
      throw error;
    }
  });
}

export { isChunkLoadError };
